import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod/v4";
import { Clients } from "../../clients/Clients";

const searchSchema = z.object({
  search: z.string().optional().default(""),
});

export const Route = createFileRoute("/kunden/")({
  validateSearch: zodValidator(searchSchema),
  component: ClientsRoute,
});

function ClientsRoute() {
  const navigate = useNavigate();
  const search = Route.useSearch({ select: ({ search }) => search });

  const setSearch = (newSearch: string) => {
    navigate({
      to: "/kunden",
      search: { search: newSearch },
    });
  };

  return <Clients search={search} setSearch={setSearch} />;
}
